import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="image-with-text"',
}

const initSwiper = (section) => {
  const swiper = section.querySelector(`[${qs.swiper}]`)
  if(swiper) {
    const autoplay = parseInt(swiper.dataset.autoplay)
    new Swiper(swiper, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      autoplay: autoplay > 0 ? {
        delay: autoplay * 1000,
      } : false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
}

const initSection = (section) => {
  initSwiper(section)
}

export const setupImageWithTexts = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}